import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=470ccc36&scoped=true&"
import script from "./TemplateForm.vue?vue&type=script&lang=js&"
export * from "./TemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ccc36",
  null
  
)

export default component.exports